// Angular
import { Component, Output, EventEmitter, Input, OnDestroy } from '@angular/core';

// Libraries
import { ColorEvent } from 'ngx-color';

// Models
import { ColorPickerChoice } from '../../models/color-picker-choice';
import { AppCleanup, ColorPickerType, Colors } from '../../models';

@Component({
	selector: 'color-picker',
	templateUrl: './color-picker.component.html',
	styleUrls: ['color-picker.component.scss'],
})
export class ColorPickerComponent extends AppCleanup implements OnDestroy {
	@Input() currentColor: string;
	@Output() colorChosen: EventEmitter<ColorPickerChoice> = new EventEmitter();
	colors: Array<string> = [...Colors.ChartDefaults];

	constructor() {
		super();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	changeColor($event: ColorEvent) {
		this.colorChosen.emit({ color: $event.color.hex } as ColorPickerChoice);
	}
}

export interface ColorPickerData {
	colors?: Array<string>;
	id?: number;
	label?: string;
	type?: ColorPickerType;
}
